import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import { useUpdateUserPreferencesMutation } from '@/api/user/index.ts';
import { useTrackEvent } from '@/App/Blotter/useTrackEvent.ts';
import { useAppSelector } from '@/store/hooks.ts';
import { getUserPreferences } from '@/store/userPreferences/slice.ts';

export const OnlyMyDealsFilter = () => {
  const track = useTrackEvent();
  const [updateUserPreferences] = useUpdateUserPreferencesMutation();
  const userPreferences = useAppSelector(getUserPreferences);

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const showMyMainDeals = event.target.checked;
      updateUserPreferences({ ...userPreferences, showMyMainDeals });
      track('Filter: only my deals', String(showMyMainDeals));
    },
    [updateUserPreferences, userPreferences],
  );

  return (
    <div className="d-flex align-items-center form-check form-check-sm form-switch sgbs-switch-colored me-2 user-select-none">
      <input
        className="form-check-input me-2"
        type="checkbox"
        id="blotter-showMyDeals-checkbox"
        data-e2e="blotter-showMyDeals-checkbox"
        checked={userPreferences.showMyMainDeals}
        onChange={handleChange}
      />
      <label
        className="form-check-label text-nowrap"
        htmlFor="blotter-showMyDeals-checkbox"
        data-e2e="blotter-showMyDeals-label"
      >
        <FormattedMessage id="blotter.filter.onlyMydeals" />
      </label>
    </div>
  );
};
